import { LocaleEnum } from '@systemeio/ui'

export const getSecureAndPayHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/2958-comment-integrer-secure-and-pay-a-systeme-io'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/2993-come-integrare-secure-and-pay-con-systeme-io'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/2985-como-integrar-secure-and-pay-con-systeme-io'
    }
    default: {
      return 'https://help.systeme.io/article/2967-how-to-integrate-secure-and-pay-with-systeme-io'
    }
  }
}
